import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { getGameAction, clearGameAction } from '../store/actions';
import GameEdit from '../components/games/GameEdit';


const mapDispatchToProps = ({
    getAGame: getGameAction,
    clearGame : clearGameAction
});


const mapStateToProps = (state) => {
    return {
        game: state.game ? state.game.data : state.game,
    }
}

const GameEditContainer =  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(GameEdit));

export default GameEditContainer;